if (typeof window.cmRemoveTrapFocus !== 'function') {
  const cmTrapFocusHandlers = {};
  //
  window.cmGetFocusableElements = function (container) {
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    );
  }
  //
  window.cmRemoveTrapFocus = function (elementToFocus = null) {
    document.removeEventListener('focusin', cmTrapFocusHandlers.focusin);
    document.removeEventListener('focusout', cmTrapFocusHandlers.focusout);
    document.removeEventListener('keydown', cmTrapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
  }
  //
  window.cmTrapFocus = function (container, elementToFocus = container) {
    var elements = cmGetFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    cmRemoveTrapFocus();

    cmTrapFocusHandlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
      )
        return;

      document.addEventListener('keydown', cmTrapFocusHandlers.keydown);
    };

    cmTrapFocusHandlers.focusout = function() {
      document.removeEventListener('keydown', cmTrapFocusHandlers.keydown);
    };

    cmTrapFocusHandlers.keydown = function(event) {
      if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
      // On the last focusable element and tab forward, focus the first element.
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }

      //  On the first focusable element and tab backward, focus the last element.
      if (
        (event.target === container || event.target === first) &&
        event.shiftKey
      ) {
        event.preventDefault();
        last.focus();
      }
    };

    document.addEventListener('focusout', cmTrapFocusHandlers.focusout);
    document.addEventListener('focusin', cmTrapFocusHandlers.focusin);

    elementToFocus.focus();
  };
}

if (typeof window.cmFocusVisiblePolyfill !== 'function') {
  window.cmFocusVisiblePolyfill = function () {
    const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
    let currentFocusedElement = null;
    let mouseClick = null;
  
    window.addEventListener('keydown', (event) => {
      if(navKeys.includes(event.code.toUpperCase())) {
        mouseClick = false;
      }
    });
  
    window.addEventListener('mousedown', (event) => {
      mouseClick = true;
    });
  
    window.addEventListener('focus', () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
  
      if (mouseClick) return;
  
      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
  
    }, true);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  cmFocusVisiblePolyfill();
}

if (typeof window.cmPauseAllMedia !== 'function') {
  window.cmPauseAllMedia = function () {
    document.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
  }
}

if (customElements.get('wavar-modal-dialog') === undefined) {
  customElements.define('wavar-modal-dialog',
    class ModalDialog extends HTMLElement {
      constructor() {
          super();
          this.querySelector('[id^="ModalClose-"]').addEventListener(
              'click',
              this.hide.bind(this, false)
          );
          this.addEventListener('keyup', (event) => {
              if (event.code.toUpperCase() === 'ESCAPE') this.hide();
          });
          if (this.classList.contains('media-modal')) {
              this.addEventListener('pointerup', (event) => {
                  if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
              });
          } else {
              this.addEventListener('click', (event) => {
                  if (event.target === this) this.hide();
              });
          }
      }
  
      connectedCallback() {
          if (this.moved) return;
          this.moved = true;
          document.body.appendChild(this);
      }
  
      show(opener) {
          this.openedBy = opener;
          const popup = this.querySelector('.template-popup');
          document.body.classList.add('overflow-hidden');
          this.setAttribute('open', '');
          if (popup) popup.loadContent();
          cmTrapFocus(this, this.querySelector('[role="dialog"]'));
          window.cmPauseAllMedia();
      }
  
      hide() {
          document.body.classList.remove('overflow-hidden');
          document.body.dispatchEvent(new CustomEvent('modalClosed'));
          this.removeAttribute('open');
          cmRemoveTrapFocus(this.openedBy);
          window.cmPauseAllMedia();
      }
    },     
  );
}


if (customElements.get('wavar-modal-opener') === undefined) {
  customElements.define('wavar-modal-opener', 
    class extends HTMLElement {
      constructor() {
          super();
  
          const button = this.querySelector('button');
  
          if (!button) return;
          button.addEventListener('click', () => {
              const modal = document.querySelector(this.getAttribute('data-wavar-modal'));
              if (modal) modal.show(button);
          });
      }
    },
  );
}
